export const TID = {
  // Navigation
  navLogo: "nav-logo",
  navHome: "nav-home",
  navCars: "nav-cars",
  navFinancing: "nav-financing",
  navAbout: "nav-about",
  navContact: "nav-contact",
  navAdmin: "nav-admin",
  navMobileToggle: "nav-mobile-toggle",

  // Home
  heroCtaCars: "hero-cta-cars",
  heroCtaContact: "hero-cta-contact",
  searchBrand: "search-brand",
  searchModel: "search-model",
  searchYear: "search-year",
  searchPriceMin: "search-price-min",
  searchPriceMax: "search-price-max",
  searchFuel: "search-fuel",
  searchTransmission: "search-transmission",
  searchKmMax: "search-km-max",
  searchSubmit: "search-submit",
  searchSmart: "search-smart",

  // Car card
  carCard: "car-card",
  carCardCta: "car-card-cta",

  // Car detail
  carDetailPhone: "car-detail-phone",
  carDetailWhatsapp: "car-detail-whatsapp",
  carDetailFinancing: "car-detail-financing",
  carDetailShare: "car-detail-share",

  // Financing form
  finName: "financing-name",
  finPhone: "financing-phone",
  finEmail: "financing-email",
  finAdvance: "financing-advance",
  finPeriod: "financing-period",
  finMessage: "financing-message",
  finSubmit: "financing-submit",

  // Contact form
  contactName: "contact-name",
  contactPhone: "contact-phone",
  contactEmail: "contact-email",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit",

  // Filters
  filterBrand: "filter-brand",
  filterBody: "filter-body",
  filterFuel: "filter-fuel",
  filterTransmission: "filter-transmission",
  filterDrivetrain: "filter-drivetrain",
  filterYearMin: "filter-year-min",
  filterYearMax: "filter-year-max",
  filterPriceMin: "filter-price-min",
  filterPriceMax: "filter-price-max",
  filterKmMax: "filter-km-max",
  filterReset: "filter-reset",
  filterSort: "filter-sort",

  // Admin
  adminEmail: "admin-email-input",
  adminPassword: "admin-password-input",
  adminLoginSubmit: "admin-login-submit",
  adminLogout: "admin-logout",
  adminSidebar: "admin-sidebar",
  adminDashboard: "admin-dashboard",
  adminCarsLink: "admin-cars-link",
  adminInquiriesLink: "admin-inquiries-link",
  adminMediaLink: "admin-media-link",
  adminSettingsLink: "admin-settings-link",
  adminAddCar: "admin-add-car",
  adminCarSave: "admin-car-save",
  adminInquiryStatus: "admin-inquiry-status",
  adminSettingsSave: "admin-settings-save",
  adminMediaUpload: "admin-media-upload",
};
